var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button",class:{
    'back-button bottom': _vm.bottom
  },on:{"click":_vm.onBack}},[_c('img',{staticClass:"back-button-image",attrs:{"alt":"back","src":require("../assets/images/back.png")}}),_vm._v("\n  Back\n")])}
var staticRenderFns = []

export { render, staticRenderFns }